import { render } from "./AdminSmsList.vue?vue&type=template&id=37323639&ts=true&lang=true"
import script from "./AdminSmsList.vue?vue&type=script&lang=ts"
export * from "./AdminSmsList.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__